<template>
<!-- <div v-if="!katudo.id" id="content">
	<div class="content-blk">
		<p>ログインIDが入力されていません。</p>
	</div>
</div> -->
<div id="content">
	<!-- ページ内ヘッダ -->
	<div class="center">
		<p>【申込までの流れ】</p>
		<ul class="pankuzu">
			<li>基本情報</li>
			<li>連絡先</li>
			<li class="selected">その他</li>
			<li>内容確認</li>
		</ul>
	</div>
	<!-- 内容 -->
	<div id="mosikomi" class="content-blk">
		<Form v-slot="{ errors }" @submit="onSubmit">
			<!-- ステップ3：その他 -->
			<div class="inner">
				<dl>
					<dt class="necessary detail_title">職業</dt>
					<dd class="flex">
						<div><Field type="radio" name="syokugyo" value="1" v-model="katudo.job" :rules="isRequired" id="sya" /><label for="sya">社会人</label></div>
						<div><Field type="radio" name="syokugyo" value="2" v-model="katudo.job" :rules="isRequired" id="syu" /><label for="syu">主婦/主夫</label></div>
						<div><Field type="radio" name="syokugyo" value="3" v-model="katudo.job" :rules="isRequired" id="gaku" /><label for="gaku">学生</label></div>
						<div><Field type="radio" name="syokugyo" value="4" v-model="katudo.job" :rules="isRequired" id="free" /><label for="free">フリーター</label></div>
						<div><Field type="radio" name="syokugyo" value="5" v-model="katudo.job" :rules="isRequired" id="mus" /><label for="mus">無職</label></div>
					</dd>
					<dd class="error">{{ errors.syokugyo }}</dd>
				</dl>
				<dl v-if="(this.katudo.job === '1') || (this.katudo.job === '3') || (this.katudo.job === '4')">
					<dt class="necessary detail_title">勤務先・学校名</dt>
					<dd><Field name="company" :rules="isCompany" v-model="katudo.company"/></dd>
					<dd>（240文字以内/例：【青森県立〇〇高等学校】）</dd>
					<dd class="error">{{ errors.company }}</dd>
				</dl>
				<dl>
					<dt class="necessary detail_title">ボランティア活動経験</dt>
					<dd class="flex">
						<div><Field type="radio" name="keiken" value="1" v-model="katudo.keiken" :rules="isRequired" id="yes" /><label for="yes">有り</label></div>
						<div><Field type="radio" name="keiken" value="2" v-model="katudo.keiken" :rules="isRequired" id="non" /><label for="non">無し</label></div>
					</dd>
					<dd class="error">{{ errors.keiken }}</dd>
				</dl>
			</div>
	<div class="button_rev justifycont-c">
		<button type="submit" class="btn_on order2">確認</button>
		<router-link to="/katudo-touroku/step2" class="order1"><button class="btn_cancel">戻る</button></router-link>
		<!-- <router-link to="/katudo-touroku/step2"><button type="submit">次へ</button></router-link> -->
	</div>
	<p v-if="Object.keys(errors).length" class="error" style="text-align: center;">未入力もしくはエラー項目があります。ご確認ください。</p>
		</Form>
	</div>
</div>
</template>

<script>
// 状態管理
import { inject } from 'vue';
import { Field, Form } from 'vee-validate';
import router from '../router';
export default {
	name: 'KatsudoTouroku4',
	components: {
		Field,
		Form,
	},
	setup(){
		const { katudo } = inject('ktouroku');
		return {
			katudo,
		};
	},
	data() {
		return {
			// katudo: {},
		};
	},
	methods: {
		onSubmit() {
			router.push({ path: '/katudo-touroku/confirm'});
		},
		// バリデーションルール
		// 必須
		isRequired(value) {
			return (value && value.length) ? true : '必須項目です';
		},
		// 会社・学校名のバリデーション
		isCompany(value) {
			if (!value || !value.length) {
				return '必須項目です。';
			}
			if (value.length > 240) {
					return '240文字以内で入力してください。';
				}
			return true;
		},
	},
}
</script>
